import '../Connect/Connect.css';
import { FaPhoneAlt, FaEnvelope, FaClock, FaMapMarkerAlt } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';

const Connect = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  // Initialize EmailJS with your User ID
  useEffect(() => {
    emailjs.init('YOUR_USER_ID'); // Replace with your EmailJS User ID
  }, []);

  useEffect(() => {
    const isValid = 
      !errors.firstName && formData.firstName &&
      !errors.lastName && formData.lastName &&
      !errors.email && formData.email &&
      !errors.phone && formData.phone &&
      formData.service &&
      !errors.message && formData.message.length >= 15;
    
    setIsFormValid(isValid);
  }, [formData, errors]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = '';
    
    switch (name) {
      case 'firstName':
      case 'lastName':
        error = /^[a-zA-Z]+$/.test(value) ? '' : 'Only alphabets allowed';
        break;
      case 'email':
        error = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Invalid email';
        break;
      case 'phone':
        error = /^\d{10}$/.test(value) ? '' : 'Must be 10 digits';
        break;
      case 'message':
        error = value.length >= 15 ? '' : 'Minimum 15 characters';
        break;
    }

    setErrors(prev => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid || isSubmitting) return;

    setIsSubmitting(true);

    try {
      // Prepare template parameters
      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone_number: formData.phone,
        service_type: formData.service,
        message: formData.message,
        to_name: "Law Firm Team"
      };

      // Send email using EmailJS
      const response = await emailjs.send(
        'YOUR_SERVICE_ID', // Replace with your EmailJS Service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS Template ID
        templateParams
      );

      // Show success message
      Swal.fire({
        title: 'Success!',
        text: 'Your message has been sent successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
    } catch (error) {
      console.error('Failed to send email:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Failed to send your message. Please try again later.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="connect-section-cc">
      <div className="connect-container-cc">
        <div className="connect-left-cc">
          <h1>Free Consultation</h1>
          <p>Law is a complex matter that can lead to significant problems if disregarded. Ignoring legal issues can have serious consequences. Allow us to assist you!</p>
          <ul className="connect-details-cc">
            <li><FaPhoneAlt className="icon-cc" /> (91) 123 456 7890</li>
            <li><FaEnvelope className="icon-cc" /> contact@lawyerfirm.com</li>
            <li><FaClock className="icon-cc" /> Mon - Fri 9.00 AM - 6.00 PM</li>
            <li><FaMapMarkerAlt className="icon-cc" /> Sector 16, Noida, Uttar Pradesh, India</li>
          </ul>
        </div>

        <div className="connect-right-cc">
          <form className="connect-form-cc" onSubmit={handleSubmit}>
            {/* First Row - Name Fields */}
            <div className="form-row-cc">
              <div style={{ position: 'relative', width: '48%' }}>
                <input 
                  type="text" 
                  name="firstName"
                  placeholder="First name*" 
                  value={formData.firstName}
                  onChange={handleChange}
                  className={errors.firstName ? 'error-border' : ''}
                />
                {errors.firstName && <span className="error-message">{errors.firstName}</span>}
              </div>
              <div style={{ position: 'relative', width: '48%' }}>
                <input 
                  type="text" 
                  name="lastName"
                  placeholder="Last name*" 
                  value={formData.lastName}
                  onChange={handleChange}
                  className={errors.lastName ? 'error-border' : ''}
                />
                {errors.lastName && <span className="error-message">{errors.lastName}</span>}
              </div>
            </div>

            {/* Second Row - Contact Fields */}
            <div className="form-row-cc">
              <div style={{ position: 'relative', width: '48%' }}>
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email*" 
                  value={formData.email}
                  onChange={handleChange}
                  className={errors.email ? 'error-border' : ''}
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>
              <div style={{ position: 'relative', width: '48%' }}>
                <input 
                  type="tel" 
                  name="phone"
                  placeholder="Phone*" 
                  value={formData.phone}
                  onChange={handleChange}
                  className={errors.phone ? 'error-border' : ''}
                />
                {errors.phone && <span className="error-message">{errors.phone}</span>}
              </div>
            </div>

            {/* Select Field */}
            <div className="form-row-cc">
              <select 
                name="service"
                value={formData.service}
                onChange={handleChange}
                className={!formData.service ? 'error-border' : ''}
              >
                <option value="">Select Service*</option>
                <option value="Corporate Law">Corporate Law</option>
                <option value="Criminal Law">Criminal Law</option>
                <option value="Family Law">Family Law</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Others">Others</option>
              </select>
              {!formData.service && <span className="error-message2">Please select a service</span>}
            </div>

            {/* Message Field */}
            <div className="form-row-cc">
              <div style={{ position: 'relative', width: '100%' }}>
                <textarea 
                  name="message"
                  placeholder="Message*" 
                  value={formData.message}
                  onChange={handleChange}
                  className={errors.message ? 'error-border' : ''}
                />
                <div style={{
                  position: 'absolute',
                  right: '10px',
                  bottom: '10px',
                  fontSize: '12px',
                  color: errors.message ? '#ff4d4f' : '#666'
                }}>
                  {formData.message.length}/15
                </div>
                {errors.message && <span className="error-message">{errors.message}</span>}
              </div>
            </div>

            <button 
              type="submit" 
              className={`submit-button-cc ${(!isFormValid || isSubmitting) ? 'disabled' : ''}`}
              disabled={!isFormValid || isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner"></span> Sending...
                </>
              ) : (
                'SUBMIT NOW'
              )}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Connect;